import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tic-hotel-card-skeleton',
  templateUrl: './hotel-card-skeleton.component.html',
  styleUrls: ['./hotel-card-skeleton.component.scss']
})
export class HotelCardSkeletonComponent implements OnInit {
  @Input() rpp: any;
  @Input() totalLeftToFetch: any;
  cardCount: number;
  
  ngOnInit(){
    this.getHotelCardCount();
  }

private getHotelCardCount(){
  if(this.totalLeftToFetch){
    if(this.totalLeftToFetch > this.rpp){
      this.cardCount = this.rpp;
    } else{
      this.cardCount = this.totalLeftToFetch;
    }
  } else{
    this.cardCount = this.rpp;
  }
}

  counter(i: number) {
    return new Array(i);
  }
  
}
